// extracted by mini-css-extract-plugin
export var avatar = "_rt-3";
export var avatarContainer = "_rt-2";
export var avatarSpacer = "_rt-5";
export var avatarSpacerContainer = "_rt-4";
export var avatarStackContainer = "_rt-1";
export var bubble = "_rt-0";
export var remainderBubble = "_rt-6";